import { useStoreon } from "storeon/react";

const toNum = (num) => {
  if (typeof num === "number") {
    return num;
  }
  if (typeof num === "string") {
    return parseFloat(num.replace(",", "."));
  }
  return parseFloat(num);
};

export const usePricePerM2 = () => {
  const { product } = useStoreon("product");
  return toNum(product?.price.sqm);
};

export const useBasePrice = (sq) => {
  const { product } = useStoreon("product");
  const pricePerM2 = toNum(product?.price.sqm);
  return sq * pricePerM2;
};

export const useColorPrice = (sq) => {
  const { product } = useStoreon("product");
  const price = useBasePrice(sq);
  const colorPricePercent = toNum(product?.price.color);
  return (price * colorPricePercent) / 100;
};

export const usePrice = (canvas) => {
  const { product } = useStoreon("product");
  const sq = canvas?.DPE.cutZone.getSquareM2();
  const basePrice = useBasePrice(sq);
  const colorPrice = useColorPrice(sq);
  const radiusPrice = toNum(product?.price.radius);
  if (!canvas) {
    return 0;
  }
  const { bgColor, cutRadius, cutW, cutH } = canvas;
  let total = basePrice;
  if (radiusPrice && canvas && cutRadius) {
    // do not add price if it is round deskpad
    if (cutW / 2 !== cutRadius && cutH / 2 !== cutRadius) {
      total += radiusPrice;
    }
  }
  if (
    colorPrice &&
    canvas &&
    bgColor &&
    bgColor !== "#fff" &&
    bgColor.toLowerCase() !== "#ffffff"
  ) {
    total += colorPrice;
  }
  return total;
};

export const useBackendPrice = () => {
  const { price, product, priceLoading } = useStoreon(
    "price",
    "product",
    "priceLoading"
  );

  const pricePlaceholder = "- - - - -";
  const defaultValues = {
    total: pricePlaceholder,
    sqm: pricePlaceholder,
    showSqm: !!product?.price.sqm,
  };

  if (!priceLoading && price) {
    const { totalPrice, pricePerSqm } = price;
    return {
      total: totalPrice ? `${totalPrice?.toDPEFormat()}€` : pricePlaceholder,
      sqm: `${pricePerSqm?.toDPEFormat()}€`,
      showSqm: !!product?.price.sqm,
    };
  }
  return defaultValues;
};
